import React, { useEffect, useState } from "react";
import styles from "../../styles/components/botDetailUser.module.scss";
import { config as axiosConfig } from "../shared/config";
import axios from "axios";

const AssociateBots = ({ parentBotID, setAssociateBotIds }) => {
  const [botIds, setBotIds] = useState([]);

  const getAssociatedBotIds = async () => {
    const payload = {
      parentBotID,
    };

    const config = {
      headers: {
        Authorization: `Bearer ${axiosConfig.bearerToken}`,
      },
    };

    try {
      if (!parentBotID) {
        console.error("parentBotID is not provided.");
        return;
      }

      const res = await axios.post(
        `${axiosConfig.baseUrl}/bot/similar-bots`,
        payload,
        config,
      );

      if (res.data?.status === "success") {
        setBotIds(res.data?.data || []);
        setAssociateBotIds(res.data?.data || []);
      }
    } catch (error) {
      console.error("Error fetching associated bot IDs:", error);
    }
  };

  useEffect(() => {
    getAssociatedBotIds();
  }, []);

  return (
    <div className={`${styles.cardRow} ${styles.fullwidth}`}>
      <div className={styles.center}>
        <p>Associated Bot Ids</p>
        {botIds.length > 0 ? (
          <div>
            {botIds.map((id, index) => (
              <span key={id}>
                {id?.botExternalId} {index !== botIds.length - 1 && ","}{" "}
              </span>
            ))}
          </div>
        ) : (
          <span>-</span>
        )}
      </div>
    </div>
  );
};

export default AssociateBots;

